<div class="container">
    <div class="content-box">
        <div class="filter">
            <keyword-search [config]="keywordSearchConfig" tid="full_keywordSearch"></keyword-search>
        </div>
        <div>
            <tam-tab-set [selectedIndex]="currentTab" (selectChange)="onTabChange($event)">
                <tam-tab *ngFor="let item of tabData; trackBy:trackByFn" [title]="item.title"
                    [editable]="item.editable">
                </tam-tab>
            </tam-tab-set>
        </div>
        <div tid="tab_notes" [hidden]="currentTab!==0" class="page-box">
            <tam-research-wrapper [config]="notesTabConfig"></tam-research-wrapper>
        </div>
        <div tid="tab_entities" *ngIf="currentTab===1" class="page-box">
            <tam-entity-list [config]="entitiesTabConfig">
            </tam-entity-list>
        </div>
        <div tid="tab_contacts" *ngIf="currentTab===2" class="page-box">
            <tam-contact-list [config]="contactsTabConfig"></tam-contact-list>
        </div>
        <div tid="tab_files" *ngIf="currentTab===3" class="page-box">
            <tam-file-view [config]="fileViewConfig"></tam-file-view>
        </div>
        <div tid="tab_livewire" *ngIf="currentTab===4" class="page-box">
            <tam-blastemail [config]="blastEmailConfig"></tam-blastemail>
        </div>
    </div>
</div>